import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from "match-sorter";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactExport from "react-data-export";
import "react-moment";
import moment from "moment";
import { notificarError } from "../componentes/Almacenes/AlmacenNotify";
import { IGV } from "../Global";
import Header from "../componentes/Header";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class ProductosMasVendidos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ProductosMasVendidos: [],
            FechaInicio: moment(new Date()).format('YYYY-MM-DD'),
            FechaFin: moment(new Date()).format('YYYY-MM-DD'),
            idSucursal: 0,
            sucursales: [],
            dataExcelReport: this.getDataProductosExportExcel([]),
            dataExcelTotales: [],
            cc: true,
            excelDataReady: false,
            loading: false,
            error: null
        };
        this.getProductosMasVendidos = this.getProductosMasVendidos.bind(this);
        this.handleSavePDF = this.handleSavePDF.bind(this);
        this.handleFechaInicio = this.handleFechaInicio.bind(this);
        this.handleFechaFin = this.handleFechaFin.bind(this);
        this.onClickExtraerMasVendidos = this.onClickExtraerMasVendidos.bind(this);
    }

    componentDidMount() {
        this.fetchSucursales();
    }

    fetchSucursales() {
        fetch('/api/sucursales/SucursalEmpresa')
            .then(res => res.json())
            .then(data => this.setState({ sucursales: data }))
            .then(() => {
                if (this.state.sucursales.length)
                    this.setState({ idSucursal: this.state.sucursales[0].IdSucursal })
            })
            .catch(error => {
                console.error('Error fetching sucursales:', error);
                notificarError("Error al cargar sucursales");
            });
    }

    async getProductosMasVendidos(Inicio, Fin) {
        this.setState({ loading: true, error: null });

        try {
            const response = await fetch(
                `/api/dashboard/get/productos-mas-vendidos-sucursal/${Inicio}/${Fin}/${this.state.idSucursal}?cc=${this.state.cc ? "1" : "0"}`
            );

            if (!response.ok) {
                throw new Error(`Error HTTP: ${response.status}`);
            }

            const ProductosMasVendidos = await response.json();

            const datosProcesados = ProductosMasVendidos.respuesta.map(item => ({
                ...item,
                totalVendidoConIgv: ((item.Cantidad * (item.Venta || 0) - (item.Descuento || 0))).toFixed(2),
                PrecioVenta: item.Venta ? item.Venta.toFixed(2) : "0.00",
                VentaOriginal: item.Venta || 0,
                Cantidad: item.Cantidad || 0
            }));

            this.setState({
                ProductosMasVendidos: datosProcesados,
                loading: false
            });

            return datosProcesados;
        } catch (error) {
            console.error('Error en getProductosMasVendidos:', error);
            this.setState({
                error: error.message,
                loading: false,
                ProductosMasVendidos: []
            });
            notificarError("Error al cargar productos más vendidos");
        }
    }

    handleFechaInicio(e) {
        let fechaInicio = e.target.value.length ? e.target.value : moment(new Date()).format('YYYY-MM-DD');
        let fechaFin = this.state.FechaFin.length ? this.state.FechaFin : moment(new Date()).format('YYYY-MM-DD');
        this.setState({
            FechaInicio: fechaInicio,
            FechaFin: fechaFin
        });
    }

    handleFechaFin(e) {
        let fechaInicio = this.state.FechaInicio.length ? this.state.FechaInicio : moment(new Date()).format('YYYY-MM-DD');
        let fechaFin = e.target.value.length ? e.target.value : moment(new Date()).format('YYYY-MM-DD');
        this.setState({
            FechaInicio: fechaInicio,
            FechaFin: fechaFin
        });
    }

    async handleSavePDF() {
        try {
            let prods = await this.getProdsForReporte();

            if (!prods || prods.length === 0) {
                notificarError("No hay datos para exportar a PDF");
                return;
            }

            let doc = new jsPDF({
                format: "a4",
                orientation: "landscape"
            });

            var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
            var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

            // Título
            doc.setFontSize(16);
            doc.setFont("helvetica", "bold");
            doc.text("REPORTE DE PRODUCTOS MÁS VENDIDOS", pageWidth / 2, 15, { align: "center" });

            // Subtítulo con fechas
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.text(`Período: ${moment(this.state.FechaInicio).format('DD/MM/YYYY')} - ${moment(this.state.FechaFin).format('DD/MM/YYYY')}`, 14, 25);
            doc.text(`Sucursal: ${this.getNombreSucursal()}`, 14, 32);

            // Formatear los datos para el PDF
            const prodsFormateados = prods.map(p => ({
                sucursal: p.sucursal || '',
                fechaVenta: p.fechaVenta || '',
                codigo: p.codigo || '',
                productoPresentacion: (`${p.nombreProducto} - ${p.presentacion}` || ''),
                cantidad: p.cantidad || 0,
                precioVenta: p.precioVenta ? Number(p.precioVenta).toFixed(2) : "0.00",
                totalVendidoConIgv: p.totalVendidoConIgv ? Number(p.totalVendidoConIgv).toFixed(2) : "0.00",
                descuento: p.descuento ? Number(p.descuento).toFixed(2) : "0",
                descAfectacion: p.descAfectacion || ''
            }));

            doc.autoTable({
                body: prodsFormateados,
                theme: "grid",
                startY: 40,
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                    lineColor: [0, 0, 0],
                    lineWidth: 0.1
                },
                columnStyles: {
                    codigo: { cellWidth: 20 },
                    productoPresentacion: { cellWidth: 55 },
                    fechaVenta: { cellWidth: 35 },
                    cantidad: { cellWidth: 20, halign: 'right' },
                    precioVenta: { cellWidth: 25, halign: 'right' },
                    totalVendidoConIgv: { cellWidth: 30, halign: 'right' },
                    descuento: { cellWidth: 25, halign: 'right' },
                    descAfectacion: { cellWidth: 30 },
                    sucursal: { cellWidth: 25 },
                },
                columns: [
                    { header: "CÓDIGO", dataKey: "codigo" },
                    { header: "PRODUCTO", dataKey: "productoPresentacion" },
                    { header: "FECHA VENTA", dataKey: "fechaVenta" },
                    { header: "CANTIDAD", dataKey: "cantidad" },
                    { header: "PRECIO VENTA", dataKey: "precioVenta" },
                    { header: "TOTAL VENDIDO", dataKey: "totalVendidoConIgv" },
                    { header: "DESCUENTO", dataKey: "descuento" },
                    { header: "AFECTACIÓN IGV", dataKey: "descAfectacion" },
                    { header: "SUCURSAL", dataKey: "sucursal" },
                ],
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: 255,
                    fontStyle: 'bold',
                    fontSize: 9,
                    halign: 'center'
                },
                alternateRowStyles: {
                    fillColor: [245, 245, 245]
                }
            });

            // Pie de página
            doc.setFontSize(8);
            doc.setFont("helvetica", "italic");
            doc.text(`Generado: ${moment().format('DD/MM/YYYY HH:mm:ss')}`, 14, pageHeight - 10);
            doc.text("Contatrib ERP", pageWidth - 14, pageHeight - 10, { align: "right" });

            doc.save("ProductosMasVendidos.pdf");

        } catch (error) {
            console.error('Error generando PDF:', error);
            notificarError("Error al generar el PDF");
        }
    }

    getNombreSucursal() {
        const sucursal = this.state.sucursales.find(s => s.IdSucursal == this.state.idSucursal);
        return sucursal ? sucursal.Nombre : 'No especificada';
    }

    sanitizeValue(value) {
        if (value === null || value === undefined) {
            return "";
        }
        if (typeof value === "number") {
            return value;
        }
        if (typeof value === "string") {
            return value.trim().replace(/[\x00-\x1F\x7F-\x9F]/g, "");
        }
        return String(value);
    }

    getDataProductosExportExcel(dataSet) {
        if (!Array.isArray(dataSet) || dataSet.length === 0) {
            return [{
                columns: [
                    { title: "Código", width: { wpx: 90 } },
                    { title: "Producto", width: { wpx: 300 } },
                    { title: "Fecha Venta", width: { wpx: 150 } },
                    { title: "Cantidad", width: { wpx: 80 } },
                    { title: "Precio Venta", width: { wpx: 100 } },
                    { title: "Total Vendido", width: { wpx: 100 } },
                    { title: "Descuento", width: { wpx: 100 } },
                    { title: "Afectación IGV", width: { wpx: 120 } },
                    { title: "Sucursal", width: { wpx: 100 } },
                ],
                data: []
            }];
        }

        // Sanitizar y validar cada fila de datos
        const data = dataSet.map(row => {
            const productoPresentacion = row.nombreProducto && row.presentacion ? `${row.nombreProducto} - ${row.presentacion}` : row.nombreProducto || row.presentacion || '';
            return [
                { value: this.sanitizeValue(row.codigo) },
                { value: this.sanitizeValue(productoPresentacion) },
                { value: this.sanitizeValue(row.fechaVenta) },
                { value: this.sanitizeValue(row.cantidad), style: { alignment: { horizontal: "center" } } },
                { value: this.sanitizeValue(row.precioVenta ? Number(row.precioVenta).toFixed(2) : "0.00"), style: { alignment: { horizontal: "center" } } },
                { value: this.sanitizeValue(row.totalVendidoConIgv ? Number(row.totalVendidoConIgv).toFixed(2) : "0.00"), style: { alignment: { horizontal: "center" } } },
                { value: this.sanitizeValue(row.descuento ? Number(row.descuento).toFixed(2) : "0"), style: { alignment: { horizontal: "center" } } },
                { value: this.sanitizeValue(row.descAfectacion) },
                { value: this.sanitizeValue(row.sucursal) },
            ];
        });

        return [{
            columns: [

                { title: "Código", width: { wpx: 90 } },
                { title: "Producto", width: { wpx: 300 } },
                { title: "Fecha de venta", width: { wpx: 150 } },
                { title: "Cantidad", width: { wpx: 80 } },
                { title: "Precio Venta", width: { wpx: 100 } },
                { title: "Total Vendido", width: { wpx: 100 } },
                { title: "Descuento", width: { wpx: 100 } },
                { title: "Afectación IGV", width: { wpx: 100 } },
                { title: "Sucursal", width: { wpx: 120 } },
            ],
            data: data
        }];
    }

    getDataProductosTotalesExportExcel(dataSet) {
        if (!Array.isArray(dataSet) || dataSet.length === 0) {
            return [{
                columns: [
                    { title: "Código", width: { wpx: 90 } },
                    { title: "Producto", width: { wpx: 300 } },
                    { title: "Presentación", width: { wpx: 150 } },
                    { title: "Cantidad Total", width: { wpx: 100 } },
                    { title: "Precio Venta Ref.", width: { wpx: 120 } },
                    { title: "Total Vendido", width: { wpx: 100 } },
                    { title: "Descuento Total", width: { wpx: 120 } },
                    { title: "Sucursal", width: { wpx: 150 } }
                ],
                data: []
            }];
        }

        const data = dataSet.map(row => {
            return [
                { value: this.sanitizeValue(row.Codigo) },
                { value: this.sanitizeValue(row.Nombre) },
                { value: this.sanitizeValue(row.NombrePresentacion) },
                { value: this.sanitizeValue(row.Cantidad), style: { alignment: { horizontal: "center" } } },
                { value: this.sanitizeValue(row.PrecioVenta ? Number(row.PrecioVenta).toFixed(2) : "0.00"), style: { alignment: { horizontal: "center" } } },
                { value: this.sanitizeValue(row.totalVendidoConIgv ? Number(row.totalVendidoConIgv).toFixed(2) : "0.00"), style: { alignment: { horizontal: "center" } } },
                { value: this.sanitizeValue(row.Descuento ? Number(row.Descuento).toFixed(2) : "0"), style: { alignment: { horizontal: "center" } } },
                { value: this.sanitizeValue(row.NombreSucursal), style: { alignment: { horizontal: "center" } } }
            ];
        });

        return [{
            columns: [
                { title: "Código", width: { wpx: 90 } },
                { title: "Producto", width: { wpx: 300 } },
                { title: "Presentación", width: { wpx: 150 } },
                { title: "Cantidad Total", width: { wpx: 100 } },
                { title: "Precio Venta Ref.", width: { wpx: 120 } },
                { title: "Total Vendido", width: { wpx: 100 } },
                { title: "Descuento Total", width: { wpx: 120 } },
                { title: "Sucursal", width: { wpx: 150 } }
            ],
            data: data
        }];
    }

    onClickExtraerMasVendidos(e) {
        if (this.state.idSucursal === 0 || this.state.idSucursal === "0") {
            notificarError("Debe seleccionar una sucursal.");
        } else {
            this.getProductosMasVendidos(this.state.FechaInicio, this.state.FechaFin)
                .then(() => this.fetchDataForExcel())
                .catch(error => {
                    console.error('Error en onClickExtraerMasVendidos:', error);
                    notificarError("Error al generar el reporte");
                });
        }
    }

    async fetchDataForExcel() {
        try {
            const prods = await this.getProdsForReporte();

            if (prods && prods.length > 0) {
                const dataExcelReport = this.getDataProductosExportExcel(prods);
                const dataExcelTotales = this.getDataProductosTotalesExportExcel(this.state.ProductosMasVendidos);
                this.setState({
                    dataExcelReport,
                    dataExcelTotales,
                    excelDataReady: true
                });
            } else {
                this.setState({
                    dataExcelReport: this.getDataProductosExportExcel([]),
                    dataExcelTotales: this.getDataProductosTotalesExportExcel([]),
                    excelDataReady: false
                });
                notificarError("No hay datos para exportar a Excel");
            }
        } catch (error) {
            console.error('Error preparing Excel data:', error);
            this.setState({
                dataExcelReport: this.getDataProductosExportExcel([]),
                dataExcelTotales: this.getDataProductosTotalesExportExcel([]),
                excelDataReady: false
            });
            notificarError("Error al preparar datos para Excel");
        }
    }

    async getProdsForReporte() {
        let prods = this.state.ProductosMasVendidos;

        if (!prods || prods.length === 0) {
            return [];
        }

        let newProds = [];

        for (let i = 0; i < prods.length; i++) {
            try {
                let ventas = await this.fetchVentasProducto(prods[i].IdProducto);

                if (!ventas || ventas.length === 0) continue;

                for (let j = 0; j < ventas.length; j++) {
                    // Validar que los datos existen antes de usarlos
                    const cantidad = ventas[j].Cantidad || 0;
                    const precioVenta = ventas[j].precioVenta || 0;
                    const descuento = ventas[j].descuento || 0;
                    const costo = prods[i].Costo || 0;

                    newProds.push({
                        costo: costo,
                        codigo: prods[i].Codigo || '',
                        sucursal: prods[i].NombreSucursal || '',
                        nombreProducto: prods[i].Nombre || '',
                        presentacion: prods[i].NombrePresentacion || '',
                        descripcion: prods[i].Descripcion || '',
                        fechaVenta: ventas[j].FechaEmision ?
                            moment(ventas[j].FechaEmision).format('DD/MM/YYYY HH:mm:ss') : '',
                        cantidad: cantidad,
                        precioVenta: precioVenta,
                        totalVendidoConIgv: (cantidad * precioVenta) - descuento,
                        descAfectacion: ventas[j].descAfectacion || '',
                        descuento: descuento,
                        utilidadUnd: precioVenta - descuento - costo,
                        utilidadTotal: (precioVenta - descuento - costo) * cantidad
                    });
                }
            } catch (error) {
                console.error(`Error procesando producto ${prods[i].IdProducto}:`, error);
                continue; // Continuar con el siguiente producto
            }
        }
        return newProds;
    }

    async fetchVentasProducto(idProd) {
        try {
            let res = await fetch(`/api/dashboard/ventas-por-prod/${this.state.FechaInicio}/${this.state.FechaFin}/${idProd}/${this.state.idSucursal}?cc=${this.state.cc ? "1" : "0"}`);

            if (!res.ok) {
                console.error(`Error fetching ventas for product ${idProd}:`, res.status);
                return [];
            }

            let data = await res.json();
            return data.ventas || [];
        } catch (error) {
            console.error(`Error in fetchVentasProducto for product ${idProd}:`, error);
            return []; // Retornar array vacío en caso de error
        }
    }

    render() {
        const { ProductosMasVendidos, dataExcelReport, dataExcelTotales, excelDataReady, loading, sucursales, idSucursal, cc, FechaInicio, FechaFin } = this.state;

        return (
            <>
                <section className="ventas-fpay-section">
                    <div className="pt-5">
                        <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2 mt-3">
                            <span className="align-self-center letra-fecha-fpay">Desde: </span>
                            <input
                                type="date"
                                onChange={this.handleFechaInicio}
                                defaultValue={FechaInicio}
                                className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                            />
                            <span className="align-self-center letra-fecha-fpay">Hasta: </span>
                            <input
                                type="date"
                                onChange={this.handleFechaFin}
                                defaultValue={FechaFin}
                                className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                            />
                        </div>
                    </div>

                    <div className="container">
                        <div className="row mb-3 align-items-center">
                            <div className="col-12 col-md-6 mb-2 mb-md-0">
                                <h3 className="mb-0">Productos más vendidos</h3>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="d-flex align-items-center justify-content-md-end">
                                    ¿Solo de ventas?
                                    <div
                                        onClick={() => this.setState({ cc: !cc })}
                                        style={{
                                            cursor: 'pointer',
                                            position: 'relative',
                                            display: 'inline-block',
                                            width: '50px',
                                            height: '24px',
                                            backgroundColor: cc ? '#01A59C' : '#ccc',
                                            borderRadius: '24px',
                                            transition: 'background-color 0.3s ease',
                                            boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)'
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={cc}
                                            onChange={() => { }}
                                            style={{ display: 'none' }}
                                        />
                                        <div style={{
                                            position: 'absolute',
                                            height: '18px',
                                            width: '18px',
                                            left: cc ? '28px' : '3px',
                                            top: '3px',
                                            backgroundColor: 'white',
                                            borderRadius: '50%',
                                            transition: 'left 0.3s ease',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                        }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mb-3">
                            <div className="caja-fondo-blanco-m-2 col-sm">
                                <label className="sucursal-text-color pad-15-fpay" htmlFor="idSucursal">
                                    Sucursal
                                </label>
                                <select
                                    name="idSucursal"
                                    id="idSucursal"
                                    className="form-control"
                                    value={idSucursal}
                                    onChange={e => this.setState({ idSucursal: e.target.value })}
                                >
                                    <option value="0">Seleccione una sucursal</option>
                                    {sucursales.map(s => (
                                        <option key={`opt_${s.IdSucursal}`} value={s.IdSucursal}>
                                            {s.Nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between mb-3">
                            <button
                                className="boton__Rojo mr-2"
                                onClick={this.handleSavePDF}
                                disabled={!ProductosMasVendidos || ProductosMasVendidos.length === 0}
                                title={!ProductosMasVendidos || ProductosMasVendidos.length === 0 ? "Genere el reporte primero" : "Exportar a PDF"}
                            >
                                <i className="fas fa-file-pdf" />
                            </button>

                            {excelDataReady && ProductosMasVendidos && ProductosMasVendidos.length > 0 ? (
                                <ExcelFile
                                    element={
                                        <button className="boton__verdeOscuro">
                                            <i className="fas fa-file-excel" />
                                        </button>
                                    }
                                    filename={`ReporteProductosMasVendidos_${moment().format('YYYYMMDD_HHmmss')}`}
                                >
                                    <ExcelSheet
                                        dataSet={dataExcelReport}
                                        name="Detalles"
                                    />
                                    <ExcelSheet
                                        dataSet={dataExcelTotales}
                                        name="Totales"
                                    />
                                </ExcelFile>
                            ) : (
                                <button
                                    className="boton__verdeOscuro"
                                    style={{ opacity: 0.5, cursor: 'not-allowed' }}
                                    disabled
                                    title="Genere el reporte primero"
                                >
                                    <i className="fas fa-file-excel" />
                                </button>
                            )}

                            <button
                                onClick={this.onClickExtraerMasVendidos}
                                className="btn btn-outline-primary btn-verde-mfp"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                        Generando...
                                    </>
                                ) : (
                                    "Generar"
                                )}
                            </button>
                        </div>

                        <ReactTable
                            id="table-productos-to-xls"
                            data={ProductosMasVendidos}
                            filterable
                            loading={loading}
                            defaultFilterMethod={(filter, row) =>
                                String(row[filter.id]) === filter.value
                            }
                            columns={[
                                {
                                    columns: [
                                        {
                                            Header: "Código",
                                            id: "Codigo",
                                            accessor: d => d.Codigo || '',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["Codigo"] }),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Producto",
                                            id: "Nombre",
                                            accessor: d => d.Nombre || '',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["Nombre"]
                                                }),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Presentación",
                                            id: "NombrePresentacion",
                                            accessor: d => d.NombrePresentacion || '',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["NombrePresentacion"]
                                                }),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Cantidad",
                                            id: "Cantidad",
                                            accessor: d => d.Cantidad || 0,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["Cantidad"]
                                                }),
                                            filterAll: true,
                                            getProps: () => {
                                                return {
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                };
                                            }
                                        },
                                        {
                                            Header: "Precio Venta",
                                            id: "PrecioVenta",
                                            accessor: d => d.PrecioVenta || "0.00",
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["PrecioVenta"]
                                                }),
                                            filterAll: true,
                                            getProps: () => {
                                                return {
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                };
                                            }
                                        },
                                        {
                                            Header: "Total Vendido",
                                            id: "totalVendidoConIgv",
                                            accessor: d => d.totalVendidoConIgv || "0.00",
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["totalVendidoConIgv"]
                                                }),
                                            filterAll: true,
                                            getProps: () => {
                                                return {
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                };
                                            }
                                        },
                                        {
                                            Header: "Descuento",
                                            id: "Descuento",
                                            accessor: d => d.Descuento || "0",
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {
                                                    keys: ["Descuento"]
                                                }),
                                            filterAll: true,
                                            getProps: () => {
                                                return {
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                };
                                            }
                                        }
                                    ]
                                }
                            ]}
                            defaultPageSize={10}
                            className="-striped -highlight"
                            previousText="Anterior"
                            nextText="Siguiente"
                            noDataText={loading ? "Cargando..." : "No se encontraron registros"}
                            loadingText="Cargando..."
                            ofText="de"
                            rowsText="filas"
                            pageText="Página"
                            pageSizeOptions={[10, 20, 25, 50, 100]}
                        />
                    </div>
                </section>
            </>
        );
    }
}

export default ProductosMasVendidos;